import React from 'react';
import { useSelector } from 'react-redux';

// Components
import RendererClassificationMethodsDropdown from '../../RendererClassificationMethods/RendererClassificationMethodsDropdown';
import ColorRangeStepsDropdown from '../../ColorRangeSteps/ColorRangeStepsDropdown';
import ColorBreaksDropdown from '../../ColorBreaksDropdown/ColorBreaksDropdown';
import SidebarMapDisableContainer from '../SidebarMapDisableContainer/SidebarMapDisableContainer';

// Store
import { $adminSelected } from '../../../store/slices/sidebarMapFiltersSlice';

// Configs
import { ADMIN__5X5km } from '../../../configs/map.configs';

// Styles
import './SidebarMapFiltersBreaks.scss';

function SidebarMapFiltersBreaks() {
  const adminSelected = useSelector($adminSelected);

  return (
    <div className={'SidebarMapFiltersBreaks__container'}>
      {adminSelected === ADMIN__5X5km && <SidebarMapDisableContainer />}

      <div className='SidebarMapFiltersBreaks__container-wrapper'>
        <h4 className={'SidebarMapFiltersBreaks__title'}>Breaks:</h4>
        <div className='SidebarMapFiltersBreaks__color-options-container'>
          <RendererClassificationMethodsDropdown />
          <ColorRangeStepsDropdown />
        </div>
        <ColorBreaksDropdown />
      </div>
    </div>
  );
}

export default SidebarMapFiltersBreaks;
